import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorQuotationRequestSearch = () => {
  const requestSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/rfq-quotation/search', payload, (response) => {
      loading(false)
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
    })
  }, [])
  return { requestSearch }
}

export default InteractorQuotationRequestSearch
